import JSZip from 'jszip'

import { orderService } from '@/services'

import { hasEmptyElements } from './array'
import { isStringNotEmpty } from './stringUltis'

export const downloadPDF = ({ fileName, file }) => {
  if (isStringNotEmpty(file) && isStringNotEmpty(fileName)) {
    const linkSource = `data:application/pdf;base64,${file}`
    const downloadLink = document.createElement('a')

    downloadLink.href = linkSource
    downloadLink.download = fileName
    downloadLink.click()
  }
}

function base64toBlob(base64Data, contentType) {
  const sliceSize = 512
  const data = base64Data.replace(/^[^,]+,/, '').replaceAll(/\s/g, '')
  const byteCharacters = globalThis.atob(data)
  const byteArrays = []

  for (let offset = 0; offset < byteCharacters.length; offset += sliceSize) {
    const slice = byteCharacters.slice(offset, offset + sliceSize)

    const byteNumbers = Array.from({ length: slice.length })
    for (let index = 0; index < slice.length; index += 1) {
      byteNumbers[index] = slice.charCodeAt(index)
    }

    const byteArray = new Uint8Array(byteNumbers)

    byteArrays.push(byteArray)
  }

  return new Blob(byteArrays, { type: contentType || '' })
}

export const downloadMultipleInvoicesZipFile = (dataArray) => {
  const zip = new JSZip()
  for (const item of dataArray) {
    zip.file(item.fileName, base64toBlob(item.file, item.contentType))
  }
  zip.generateAsync({ type: 'blob' }).then((content) => {
    const blobUrl = URL.createObjectURL(content)
    const downloadLink = document.createElement('a')

    downloadLink.href = blobUrl
    downloadLink.download = 'Invoices.zip'
    downloadLink.click()
  })
}

export const getInvoices = (invoiceNumbers) => {
  if (!hasEmptyElements(invoiceNumbers)) {
    return orderService.getMultipleInvoicesByInvoiceNumbers({
      invoiceNumbers,
    })
  }

  return Promise.reject(new Error('Invoice numbers cannot be empty'))
}
